import { PatientInfoValues } from '../enums/patient-info-values.enum';

export const PatientInfoValueType = {
  [PatientInfoValues.OWNER_EMAIL]: 'email',
  [PatientInfoValues.OWNER_PHONE_NUMBER]: 'phone'
};
